var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7412 4.0918C7.74371 7.5043 5.74121 10.4518 5.74121 12.9418C5.74121 16.6768 8.59121 19.0918 11.7412 19.0918C14.8912 19.0918 17.7412 16.6768 17.7412 12.9418C17.7412 10.4518 15.7387 7.5043 11.7412 4.0918ZM11.7412 17.5918C9.22871 17.5918 7.24121 15.6643 7.24121 12.9418C7.24121 11.1868 8.70371 8.8618 11.7412 6.0868C14.7787 8.8618 16.2412 11.1793 16.2412 12.9418C16.2412 15.6643 14.2537 17.5918 11.7412 17.5918ZM8.61371 13.0918C8.89121 13.0918 9.11621 13.2868 9.16871 13.5568C9.47621 15.2218 10.8787 15.7918 11.8987 15.7093C12.2212 15.6943 12.4912 15.9493 12.4912 16.2718C12.4912 16.5718 12.2512 16.8193 11.9512 16.8343C10.3537 16.9318 8.48621 16.0168 8.05871 13.7443C8.04568 13.6639 8.05026 13.5816 8.07215 13.5031C8.09404 13.4247 8.13272 13.3519 8.18549 13.2899C8.23827 13.2278 8.3039 13.178 8.37783 13.1438C8.45177 13.1096 8.53225 13.0918 8.61371 13.0918Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/Humidity.7602020086757487dce6e8483414bd4e.svg";
export { ForwardRef as ReactComponent };